import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 704F7397-0E85-4213-8D76-FE156DF1795F
 * name download
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/download.svg
 * tags
 */
export const DownloadIcon = createSvgIcon(<><path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" /></>, 'DownloadIcon');
export default DownloadIcon